import React, { FC } from "react";
import cn from "classnames";
import { OnChangeInput } from "src/@types/form";
import { ReactComponent as DownloadIcon } from "src/assets/icons/download.svg";
import { formatBytes } from "src/utils/formatBytes";
import { ReactComponent as RemoveIcon } from "src/assets/icons/x-mark.svg";
import { Button } from "../Button";

interface Props {
  files: File[];
  onChange: OnChangeInput;
  onDelete: (file: File) => void;
  id?: string;
  isUploaded?: boolean;
  placeholder?: string;
  className?: string;
  accept?: string;
}
export const MultiFileInput: FC<Props> = ({
  id,
  isUploaded,
  className,
  placeholder,
  onChange,
  onDelete,
  accept,
  files,
}) => {
  const combinedClassNames = cn(
    "relative flex flex-col gap-3 py-3 px-5 text-xl text-purple-base border border-black-base/20 rounded-20 cursor-pointer",
    {
      "bg-purple-lighter transition-none justify-between": isUploaded,
    },
    className
  );
  const onClick = (file: File) => (e: React.MouseEvent) => {
    e.preventDefault();
    onDelete(file);
  };

  return (
    <label className={combinedClassNames} htmlFor={id}>
      {/* placeholder (from) */}
      {!files?.length && (
        <div className="flex gap-2 lg:gap-5 justify-center items-center">
          <DownloadIcon className="sm:w-10 sm:h-10" />{" "}
          <span className="max-w-36 sm:max-w-98 !truncate text-center">
            {placeholder}
          </span>
        </div>
      )}
      {/* placeholder (to) */}

      {files?.map((file) => (
        <div
          key={String(file.name + file.size)}
          className="flex justify-between items-center"
        >
          <div className="flex items-center gap-2">
            <DownloadIcon className="sm:w-10 sm:h-10" />
            <div className="max-w-36 sm:max-w-90 !truncate text-center">
              {file.name}
            </div>
            <span className="text-sm md:text-base">
              {formatBytes(file.size)}
            </span>
          </div>
          <Button type="button" onClick={onClick(file)} className="md:p-2">
            <RemoveIcon />
          </Button>
        </div>
      ))}
      <input
        id={id}
        type="file"
        className="hidden"
        accept={accept}
        onChange={onChange}
        multiple
      />
    </label>
  );
};
